<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="30"
    height="30.026"
    viewBox="0 0 30 30.026"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_476"
          data-name="Rectangle 476"
          width="30"
          height="30.026"
          transform="translate(0 0)"
          :fill="color"
        />
      </clipPath>
    </defs>
    <g id="Group_660" data-name="Group 660" transform="translate(-13 -8)">
      <g
        id="Group_660-2"
        data-name="Group 660"
        transform="translate(13 8)"
        clip-path="url(#clip-path)"
      >
        <path
          id="Path_1512"
          data-name="Path 1512"
          d="M16.225,0c2.707,0,5.415-.011,8.121,0a5.572,5.572,0,0,1,5.517,4.424,5.728,5.728,0,0,1,.128,1.254q.014,8.088,0,16.175a5.583,5.583,0,0,1-4.724,5.623,6.848,6.848,0,0,1-1.19.082q-5.8.007-11.6,0a.807.807,0,0,0-.634.276A6.573,6.573,0,0,1,4.7,29.632,6.506,6.506,0,0,1,.053,23.879,6.538,6.538,0,0,1,2.189,18.14a.753.753,0,0,0,.254-.608q-.009-5.891,0-11.78A5.588,5.588,0,0,1,6.379.277,6.743,6.743,0,0,1,8.245.017C10.9-.011,13.565,0,16.225,0m5.543,1.448V1.97c0,2.051.008,4.1,0,6.153A1.973,1.973,0,0,1,18.71,9.89c-.734-.414-1.471-.824-2.193-1.258a.5.5,0,0,0-.6.009c-.723.433-1.46.842-2.193,1.259a1.995,1.995,0,0,1-3.053-1.828c-.007-2.039,0-4.078,0-6.118V1.5c-.544,0-1.057-.013-1.569,0a10.856,10.856,0,0,0-1.922.114A4.06,4.06,0,0,0,3.952,5.745q-.01,5.4,0,10.794v.36c2.906-1.119,5.556-.777,7.751,1.427s2.521,4.849,1.407,7.732h.248q5.468,0,10.933,0a4.146,4.146,0,0,0,4.213-4.2c.008-2.883,0-5.767,0-8.65,0-2.508.007-5.016,0-7.524a4.013,4.013,0,0,0-3.258-4.063,26.828,26.828,0,0,0-3.475-.169M12.209,23.135a5.354,5.354,0,1,0-5.347,5.371,5.339,5.339,0,0,0,5.347-5.371M20.275,1.522H12.192c-.005.114-.012.206-.012.3q0,3.111,0,6.222c0,.63.329.819.88.507.876-.5,1.756-.985,2.621-1.5a.955.955,0,0,1,1.081,0c.845.5,1.7.981,2.556,1.47.631.362.956.181.957-.535q0-1.232,0-2.461v-4"
          :fill="color"
        />
        <path
          id="Path_1515"
          data-name="Path 1515"
          d="M5.839,23.974,8.81,21a4.17,4.17,0,0,1,.3-.292.75.75,0,0,1,.994.028.738.738,0,0,1,.079.99,1.674,1.674,0,0,1-.164.183q-1.752,1.752-3.505,3.5a.805.805,0,0,1-1.326.005c-.506-.505-1.013-1.009-1.515-1.517a.766.766,0,0,1-.069-1.146.746.746,0,0,1,1.12.082c.366.363.721.736,1.112,1.136"
          :fill="color"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "Shipment_Success_Icon",
  props: {
    color: {
      default: "#1C274C",
    },
  },
};
</script>
